import socket from '@/plugins/socket'
import { date } from '@/helpers/format'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    load: (state, datas) => {
      state.list = datas.sort((a, b) => {
        if (a.rankink && b.ranking && a.rankink > 0 && b.ranking > 0) {
          return b.ranking - a.ranking
        } else if (a.order && b.order) {
          return b.order - a.order
        } else {
          return -1
        }
      })
    },
    single: (state, datas) => {
      if (datas) {
        for (const i in datas) {
          const dataCompetitor = datas[i]
          const competitor = state.list.find(item => item.id === dataCompetitor.id)
          if (competitor) {
            for (const j in dataCompetitor) {
              if (dataCompetitor[j] !== competitor[j]) {
                competitor[j] = dataCompetitor[j]
              }
            }
          } else {
            state.list.push(dataCompetitor)
          }
        }
      }
    },
    delete: (state, datas) => {
      if (datas) {
        for (const i in datas) {
          const dataCompetitor = datas[i]
          const index = state.list.findIndex(item => item.id === dataCompetitor.id)
          if (index > -1) {
            state.list.splice(index, 1)
          }
        }
      }
    }
  },
  actions: {
    set (state, data) {
      if (data.sportId > 0 || data.competitionsId > 0 || data.dateStart || data.dateEnd) {
        state.state.list = []
        state.state.loading = true

        const parameters = {
          join: [
            'SportSportCompetitor.gameId',
            'SportSportGame.dayId',
            'SportSportDay.groupId',
            'SportSportGroup.roundId',
            'SportSportRound.competitionSeasonId',
            'SportSportRound.eventUnitId',
            'SportSportEventunit.eventId',
            'SportSportEvent.disciplineId'
          ]
        }

        if (data.dateStart) {
          parameters.dateStart = { column: 'SportSportGame.date', operator: '>=', value: date(data.dateStart) }
        }
        if (data.dateEnd) {
          const dateEnd = new Date(data.dateEnd.getTime())
          dateEnd.setDate(dateEnd.getDate() + 1)
          parameters.dateEnd = { column: 'SportSportGame.date', operator: '<=', value: date(dateEnd) }
        }

        if (data.dayId > 0) {
          parameters['SportSportGame.dayId'] = data.dayId
        } else {
          if (data.groupsTypeId > 0) {
            if (data.groupsTypeId.length === 1) {
              parameters['SportSportGroup.groupTypeId'] = data.groupsTypeId[0]
            } else {
              parameters['SportSportGroup.groupTypeId'] = {
                column: 'SportSportGroup.groupTypeId',
                operator: 'in',
                value: data.groupsTypeId
              }
            }
          }

          if (data.roundsTypeId > 0) {
            if (data.roundsTypeId.length === 1) {
              parameters['SportSportRound.roundTypeId'] = data.roundsTypeId[0]
            } else {
              parameters['SportSportRound.roundTypeId'] = {
                column: 'SportSportRound.roundTypeId',
                operator: 'in',
                value: data.roundsTypeId
              }
            }
          }

          // competition
          if (data.seasonId > 0 || data.competitionsId.length > 0) {
            if (data.seasonId > 0) {
              parameters['SportSportCompetitionseason.seasonId'] = data.seasonId
            }

            if (data.competitionsId.length === 1) {
              parameters['SportSportCompetitionseason.competitionId'] = data.competitionsId[0]
            } else if (data.competitionsId.length > 1) {
              parameters['SportSportCompetitionseason.competitionId'] = {
                column: 'SportSportCompetitionseason.competitionId',
                operator: 'in',
                value: data.competitionsId
              }
            }
          }

          // discipline
          if (data.eventUnitsId > 0) {
            parameters['SportSportRound.eventUnitId'] = {
              value: data.eventUnitsId,
              operator: 'in'
            }
          } else if (data.eventUnitId > 0) {
            parameters['SportSportEventunit.id'] = data.eventUnitId
          } else {
            if (data.categoryId > 0) {
              parameters['SportSportEventunit.categoryId'] = data.categoryId
            }

            if (data.eventId > 0) {
              parameters['SportSportEventunit.eventId'] = data.eventId
            } else if (data.disciplineId > 0) {
              parameters['SportSportEvent.disciplineId'] = data.disciplineId
            } else if (data.sportId > 0) {
              parameters['SportSportDiscipline.sportId'] = data.sportId
            }

            if (data.genderId > 0) {
              parameters['SportSportEventunit.genderId'] = data.genderId
            }

            // todo : Classification
          }
        }

        socket.get('SportSportCompetitor', 'Sport/Competitor/load', parameters)
      }
    },
    post (state, data) {
      socket.post('SportSportCompetitor', 'Sport/Competitor/single', data)
    },
    delete (state, competitorId) {
      socket.delete('SportSportCompetitor', 'Sport/Competitor/delete', { id: competitorId })
    },
    put (state, parameters) { socket.put('SportSportCompetitor', 'Sport/Competitor/single', parameters) }
  },
  getters: {
    getGame: (state) => (gameId) => state.list.filter(item => item.gameId === gameId)
  }
}
